<template>
  <div id="deal-documents" class="box">
    <section-header title="Deal Documents" parentSelector="#deal-documents"></section-header>
    <table class="table is-narrow is-hoverable is-fullwidth deal-document-checklist">
      <thead>
        <tr>
          <th>Document</th>
          <th>Vehicle</th>
          <th>Status</th>
          <th class="has-text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.key">
          <td>{{ row.title }}</td>
          <td>{{ row.vehicle }}</td>
          <td>
            <span v-tooltip="row.tooltip">{{ row.statusText }}</span>
            <div class="is-size-7 has-text-grey" v-if="row.hint">{{ row.hint }}</div>
          </td>
          <td class="has-text-right">
            <a class="checklist-action" @click="$emit('download', row)" v-if="row.isComplete" v-tooltip="'Click to download the signed document.'">
              <i class="icon fal fa-lg has-text-success" :class="row.icon"/>
            </a>
            <a class="checklist-action" @click="$emit('send', row)" v-else-if="row.canSend" v-tooltip="'Click to ' + row.sendLabel.toLowerCase() + ' this document for signing.'">
              <i class="icon fal fa-lg" :class="[row.icon, row.sendLabel === 'Resend' ? 'has-text-orange' : 'has-text-danger']"/>
            </a>
            <span class="checklist-action is-disabled" :title="row.disabledReason" v-else-if="row.disabledReason">
              <i class="icon fal fa-lg has-text-grey-light" :class="row.icon"/>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SectionHeader from '@/components/generic/SectionHeader'

export default {
  name: 'DealDocumentChecklist',
  components: {
    'section-header': SectionHeader
  },
  props: {
    rows: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
  .deal-document-checklist td {
    vertical-align: middle;
  }

  .deal-document-checklist .checklist-action.is-disabled {
    cursor: not-allowed;
  }
</style>
